import { StandardEvents } from '@shopify/events';

/**
 * Text that follows the selected variant. When a variant is selected in the
 * same section, the theme fetches the section HTML for that variant; this
 * element copies the content of its counterpart (same data-key) from that HTML.
 * Used by blocks/gualss-per-glass.liquid.
 */
class GualssLiveText extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    this.#controller = new AbortController();
    section.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    try {
      const { detail } = await event.promise;
      const html = detail?.html;
      if (!html) return;

      const key = CSS.escape(this.dataset.key ?? '');
      const next = html.querySelector(`gualss-live-text[data-key="${key}"]`);
      if (next) this.innerHTML = next.innerHTML;
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') return;
      console.warn('[gualss-live-text]', error);
    }
  };
}

if (!customElements.get('gualss-live-text')) {
  customElements.define('gualss-live-text', GualssLiveText);
}
